export const BEFORE_COMPETITION_OPEN_MESSAGE = "Opening November 2025";
export const CLOSED_MESSAGE =
  "Entries for this competition have now closed. The finalists will be announced in March 2026.";
export const STUDENT_MESSAGE = "Ask your teacher about submitting your project.";
export const TEACHER_MESSAGE = "Teachers, login to submit a student project.";
